import Vue from "vue";
import { extend, localize } from "vee-validate";
import { required, email, min, confirmed} from "vee-validate/dist/rules";
import * as CustomRules from './custom-rules.js'
import ja from "vee-validate/dist/locale/ja.json";
import en from "vee-validate/dist/locale/en.json";

// Install required rule.
extend("required", required);
extend("email", email);
extend("min", min);
extend("confirmed", confirmed);

for (const rule in CustomRules) {
  extend(rule, CustomRules[rule])
}

// Install English and jp localizations.
localize({
  en: {
    messages: en.messages,
    names: {
      email: "E-mail Address",
      password: "Password",
      first_name: "first_name"
    },
    fields: {
      password: {
        password:  'Must contain uppercase letters, numbers, and symbols.',
      },
      email: {
        email: "your email is not email format. check your email."
      }
    }
  },
  ja: {
    messages: ja.messages,
    names: {
      email: "メールアドレス",
      password: "パスワード",
      password_confirm: "パスワード",
      first_name: "名",
      midle_name: "ミドルネーム",
      family_name: "姓",
      phone: "電話番号",
      idtype: "IDタイプ",
      confirm: "確認コード",
      nowPass: "現在のパスワード",
      newPass: "新しいパスワード",
      org_name: '事業者名',
      org_scale: '規模',
      org_zip: '郵便番号',
      org_adress1: '都道府県',
      org_adress2: '市区町村',
      org_adress3: '番地・マンション名',
      org_industry: '業種',
      org_category: 'カテゴリー',
      org_description: '説明',
      org_established_at: '設立年',
      staff_name: 'ユーザー名',
      title_name: '職種名または作業名',
      occupation: '職種',
      occupation_category: '職種カテゴリー',
      employment_status: '雇用形態',
      public_status: '公開ステータス',
      min_salary: '最低給与',
      max_salary: '最高給与',
      work_location: '勤務地',
      work_content: '仕事内容',
      work_start_time: '始業時間',
      work_end_time: '終業時間',
      catch_copy: '求人キャッチコピー',
      company_name: '雇用企業名',
      salary_type: '給与タイプ',
      work_content_appeal_desc: '仕事内容及びアピールポイント',
      org_title_name: '貴社名',
      representative_name: '代表者名',
      representative_role: '代表者役職',
      address1: '都道府県',
      address2: '市区町村',
      address3: '番地・マンション名',
      capital: '資本金',
      charge_name: '担当者名',
      charge_role: '担当者役職',
      established_at: '設立年',
      corporate_number: '企業番号',
      job_name: '職種名',
      work_name: '作業名',
      main_products: '主要製品',
      number_fulltime_employees: '常勤職員数',
      number_clerks: '事務部員のみ人数',
      number_staff: '現場部員のみ人数',
      url: '会社HPのURL',
      description: '会社概要',
      is_cheating: '不正行為もしくは不正行為に準ずる行為を行なっていないか',
      is_labor_standards_act: '労働基準法違反の指摘',
      insurance_coverage: '保険加入状況',
      holiday: '休日',
      salary_form: '給与形態',
      similar_japanese_salary: '実習生と同程度の技能等を有する日本人を雇用する場合の給与',

      salary_month: '賃金(締切日)',
      salary_way: '賃金(支払い方法)',
      salary_day: '代表者役職',
      working_time: '勤務時間',
      overtime: '月残業時間',
      is_technical_intern: '現在技能実習生を受け入れていますか？',
      internal_role: '社内管理責任者(役職)',
      internal_name: '社内管理責任者(名前)',
      internal_experience: '社内管理責任者(経験年数)',
      instructor_role: '社内管理指導者(役職)',
      instructor_name: '社内管理指導者(名前)',
      instructor_experience: '社内管理指導者(経験年数)',
      instructor_license: '社内管理指導者(資格保有)',
      license_name: '資格名',
      license_date: '取得年月日',
      job_title_name: '求人名'
    },
    fields: {
      password: {
        password: "大文字,数字,記号が含まれていなければいけません。"
      },
      email: {
        email: "不正な{_field_}です。メールアドレスを確認してください。"
      },
      phone:{
        phone: "不正な電話番号です。"
      },
      nowPass: {
        password: "大文字,数字,記号が含まれていなければいけません。"
      },
      newPass: {
        password: "大文字,数字,記号が含まれていなければいけません。"
      },
    }
  }
});

let LOCALE = "ja";
localize(LOCALE)
// A simple get/set interface to manage our locale in components.
// This is not reactive, so don't create any computed properties/watchers off it.
Object.defineProperty(Vue.prototype, "locale", {
  get() {
    return LOCALE;
  },
  set(val) {
    LOCALE = val;
    localize(val);
  }
});
